// import { throttle } from '../utils'
import { addClickEvent } from './click'
import show from './show'
// import { exposure } from '../BsTrackExp'

const throttle = (func, delay) => {
    let timer = null
    return () => {
      clearTimeout(timer)
      timer = setTimeout(func, delay)
    }
  }
// 添加事件、展示、曝光
function mutation(fn, exp) {
  let mutationObserver = new MutationObserver(throttle(function() {
      addClickEvent(fn)
      show(fn)
      exp && exp.exposure(fn)
    }, 500)
  )
  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  })
}

function mutationEvent(fn, exp) {
  document.addEventListener('DOMNodeInserted',throttle(function() {
      addClickEvent(fn)
      show(fn)
      exp && exp.exposure(fn)
    }, 500)
  )
}
export default function(fn, exp) {
  try {
    if (window.MutationObserver) {
      mutation(fn, exp)
    } else {
      mutationEvent(fn, exp)
    }
  } catch (error) {
    console.log(error);
  }
}
